import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { convertKeyValueToObject } from '../../../utils/helpers';
import UrlEditor from '../../Panes/RequestUrl/UrlEditor';
import RequestTabGroup from '../../Tab-Groups/RequestTabGroup';

const keyPairInitState = [
  {
    id: uuidv4(),
    keyItem: '',
    valueItem: '',
  },
];

export default function Request({ setResponse, setLoading, setHistory, selectedRequest }) {
  const [url, setUrl] = useState('https://jsonplaceholder.typicode.com/todos/1');
  const [reqMethod, setReqMethod] = useState('GET');
  const [queryParams, setQueryParams] = useState(keyPairInitState);
  const [headers, setHeaders] = useState(keyPairInitState);
  const [body, setBody] = useState('{\n\t\n}');
  const [loading, setLocalLoading] = useState(false);

  useEffect(() => {
    if (selectedRequest) {
      setUrl(selectedRequest.url || '');
      setReqMethod(selectedRequest.method || 'GET');
      
      if (selectedRequest.params && selectedRequest.params.length > 0) {
        setQueryParams(selectedRequest.params.map(p => ({
          id: uuidv4(),
          keyItem: p.key || '',
          valueItem: p.value || '',
        })));
      } else {
        setQueryParams(keyPairInitState);
      }
      
      if (selectedRequest.body) {
        setBody(JSON.stringify(selectedRequest.body, null, 2));
      } else {
        setBody('{\n\t\n}');
      }
    }
  }, [selectedRequest]);

  const handleOnInputSend = async (e) => {
    e.preventDefault();
    
    if (!url.trim()) {
      alert('Please enter a URL');
      return;
    }
    
    setLocalLoading(true);
    setLoading(true);
    
    const requestBody = body.toString();
    let data;
    
    if (reqMethod !== 'GET' && requestBody.trim() !== '' && requestBody !== '{\n\t\n}') {
      try {
        data = JSON.parse(requestBody);
      } catch (e) {
        alert('Invalid JSON in request body: ' + e.message);
        setLocalLoading(false);
        setLoading(false);
        return;
      }
    }

    try {
      const response = await axios({
        url: url,
        method: reqMethod,
        params: convertKeyValueToObject(queryParams),
        headers: convertKeyValueToObject(headers),
        data,
      });

      setResponse(response);
      setHistory((prev) => [
        {
          method: reqMethod,
          url,
          status: response.status,
          timestamp: new Date().toISOString(),
        },
        ...prev,
      ]);
    } catch (e) {
      console.log('Request error:', e);
      const errorResponse = {
        data: { 
          error: e.message,
          details: e.response?.data || 'Network error or CORS issue'
        },
        status: e.response?.status || 'Network Error',
        headers: e.response?.headers || {},
        customData: { time: 0 }
      };
      setResponse(errorResponse);
      setHistory((prev) => [
        {
          method: reqMethod,
          url,
          status: e.response?.status || 'CORS/Network Error',
          timestamp: new Date().toISOString(),
        },
        ...prev,
      ]);
    }

    setLocalLoading(false);
    setLoading(false);
  };

  return (
    <div className="flex flex-col h-full gap-4">
      {/* URL Editor */}
      <div className="flex-shrink-0">
        <UrlEditor
          url={url}
          setUrl={setUrl}
          reqMethod={reqMethod}
          setReqMethod={setReqMethod}
          onInputSend={handleOnInputSend}
          loading={loading}
        />
      </div>
      
      {/* Request Details */}
      <div className="flex-1 flex flex-col min-h-0">
        <RequestTabGroup
          queryParams={queryParams}
          setQueryParams={setQueryParams}
          headers={headers}
          setHeaders={setHeaders}
          body={body}
          setBody={setBody}
        />
      </div>
    </div>
  );
}